import { configureStore } from "@reduxjs/toolkit";

import cartReducer, { CartState } from "./cartSlice/cartSlice";
import flightCartReducer from "./travelSlice/flightCartSlice";
import flightReducer from "./travelSlice/amadeusFlightSlice";

import { productApi } from "../productApi/productAPI";
import { orderApi } from "../orderApi/orderApi";
import { waybillApi } from "../orderApi/waybillApi";
import { amadeusApi } from "../orderApi/amadeusApi";
import { accommodationApi } from "./travelSlice/accommodationApi";
import { busApi } from "./travelSlice/busApi";
import { carApi } from "./travelSlice/carApi";
import { flightApi } from "./travelSlice/flightApi";

import hikeTripsReducer from "./travelSlice/hikeTripsSlice";
import hikeCarsReducer from "./travelSlice/hikeCarsSlice";

import { deliveryApi } from "./deliverySlice/deliveryApi";
import deliveryRequestsReducer from "./deliverySlice/deliverySlice";
import { partsApi } from "../CarPartsModule/Api/partsApi";
import { fitmentApi } from "../CarPartsModule/Api/fitmentApi";
import { pinManagementApi } from "../components/Pins/pinManagementApi";
import { inventoryApi } from "../InventoryStockModule/inventoryApi";

// Load cart from localStorage
const loadCartFromLocalStorage = (): CartState => {
  try {
    const stored = localStorage.getItem("cart");
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        items: Array.isArray(parsed.items) ? parsed.items : [],
        total: typeof parsed.total === "number" ? parsed.total : 0,
      };
    }
  } catch {
    return { items: [], total: 0 };
  }
  return { items: [], total: 0 };
};

export const store = configureStore({
  reducer: {
    [productApi.reducerPath]: productApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [waybillApi.reducerPath]: waybillApi.reducer,
    [amadeusApi.reducerPath]: amadeusApi.reducer,
    [flightApi.reducerPath]: flightApi.reducer,
    [carApi.reducerPath]: carApi.reducer,
    [busApi.reducerPath]: busApi.reducer,
    [accommodationApi.reducerPath]: accommodationApi.reducer,
    [deliveryApi.reducerPath]: deliveryApi.reducer,
    [partsApi.reducerPath]: partsApi.reducer,
    [fitmentApi.reducerPath]: fitmentApi.reducer,
    [pinManagementApi.reducerPath]: pinManagementApi.reducer,
    [inventoryApi.reducerPath]: inventoryApi.reducer,

    cart: cartReducer,
    flightCart: flightCartReducer,
    flight: flightReducer,
    hikeTrips: hikeTripsReducer,
    hikeCars: hikeCarsReducer,
    deliveryRequests: deliveryRequestsReducer,
  },
  preloadedState: {
    cart: loadCartFromLocalStorage(),
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      productApi.middleware,
      orderApi.middleware,
      waybillApi.middleware,
      amadeusApi.middleware,
      flightApi.middleware,
      carApi.middleware,
      busApi.middleware,
      accommodationApi.middleware,
      deliveryApi.middleware,
      partsApi.middleware,
      fitmentApi.middleware,
      pinManagementApi.middleware,
      inventoryApi.middleware,
    ),
});

store.subscribe(() => {
  localStorage.setItem("cart", JSON.stringify(store.getState().cart));
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
